import { Div } from "@tblabs/truffle";


export class ConnectingLine extends Div
{
    constructor()
    {
        super("invisible-on-mobile");

        this.Append(
            new Div().Class("connecting-line"),
        );
    }
}
